import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import getTranslatedText from '../../services/getTranslatedText';
import WidgetHeader from '../../components/WidgetHeader';
import WidgetFooter from '../../components/WidgetFooter';
import ShowIfAnswersCount from '../../components/ShowIfAnswersCount';

export default (config = {}) => (WrappedComponent) => {
  class EnhancedComponent extends Component {
    constructor(props) {

      super(props);
      this.state = {
        headerHeight: -1,
        footerHeight: -1,
      };
    }

    handleHeaderHeightChange = (height) => {
      this.setState({ headerHeight: height });
    };

    handleFooterHeightChange = (height) => {
      this.setState({ footerHeight: height });
    };

    render() {
      const widget = this.props.widget;
      const widgetConfig = widget.config;
      const question = widgetConfig.question;
      const answersReport = question ? (question.answersReport || {}) : {};

      let bodyHeight = this.props.height;
      if (!config.hideFooter) {
        bodyHeight -= this.state.footerHeight;
      }
      if (!widgetConfig.hideHeader) {
        bodyHeight -= this.state.headerHeight;
      }

      const subtitle = widgetConfig.subtitle === ''
        ? null
        : (widgetConfig.subtitle ||
          (config.subtitleMessageId && this.props.intl.formatMessage({ id: config.subtitleMessageId })));

      return (
        <div style={{ textAlign: 'left' }}>
          {!widgetConfig.hideHeader && (
            <WidgetHeader
              title={widget.name || (question ? getTranslatedText((question.text || ''), this.props.intl.locale) : '')}
              subtitle={subtitle}
              onHeightChange={this.handleHeaderHeightChange}
            />
          )}
          <ShowIfAnswersCount
            answersCount={answersReport.count}
            height={this.props.height - this.state.headerHeight}
          >
            <WrappedComponent
              bodyHeight={bodyHeight}
              {...this.props}
            />
            {!config.hideFooter && (
              <WidgetFooter
                answersCount={answersReport.count}
                onHeightChange={this.handleFooterHeightChange}
              />
            )}
          </ShowIfAnswersCount>
        </div>
      );
    }
  }

  const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
  EnhancedComponent.displayName = `WithWidgetHeaderAndFooter(${wrappedComponentName})`;

  return injectIntl(EnhancedComponent);
};



// WEBPACK FOOTER //
// ./src/components/withWidgetHeaderAndFooter/withWidgetHeaderAndFooter.js